const validateItem = (item = null) => {
  if (item === null) {
    throw new TypeError("item is required");
  }
};

export default validateItem;
